module.exports = __webpack_public_path__ + "static/media/money.cdcb48c0.png";